import React from "react";
import ShineButton from "../../../atoms/shine-button";
import get from 'lodash/get';
import { connect, useSelector } from "react-redux";
import "./subscription-banner.m.css";
import { subscribeClick } from '../../../../helpers/datalayer-utils';

const SubscriptionBanner = ({ features }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  const handleClick = () => {
    subscribeClick(userData, pageType, 'subscription-page-footer')
    setTimeout(() => {
      const element = document.getElementById("subscription-home");
      if (element) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 100); // intentional Delay scrolling added by 100ms
  };

  return (
    <div className="container">
      <div styleName="subscription-banner">
        <img
          src="/images/subscription-left-banner.png"
          className="desktop-only"
          styleName="card-image"
        />
        <div styleName="middle-card">
          <div styleName="title">
            Cheaper than a cup of Chai ☕
          </div>
          <div styleName="btn-wrap" onClick={() => handleClick()}>
            <ShineButton
              className="shine-button"
              size="medium"
              label={`Subscribe at ₹${features?.subscription?.subscription_btn_amount}/day`}
              rounded="full"
            >
              <img src="/icons/ic_chevron_right_white_24px.svg" />
            </ShineButton>
          </div>
          <div styleName="desc">Save more on yearly plans</div>
        </div>
        <img
          src="/images/subscription-right-banner.png"
          className="desktop-only"
          styleName="card-image"
        />
        <img
          src="/images/subscription-mb-banner.png"
          className="mobile-only"
          styleName="card-image"
        />
        <img src="/images/story_top_img.svg" styleName="bottom-banner left" />
        <img src="/images/story_top_img.svg" styleName="bottom-banner right" />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  features: get(state, ['qt', 'config', 'features'], {}),
});

export default connect(mapStateToProps)(SubscriptionBanner);

